import { createContext, ReactNode, useContext, useState } from "react"

type MenuContextType = {
  open: boolean
  setOpen: (open: boolean) => void
}

export const MenuContext = createContext<MenuContextType | undefined>(undefined)

export const MenuProvider = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false)
  return <MenuContext.Provider value={{ open, setOpen }}>{children}</MenuContext.Provider>
}

export const useMenuContext = () => {
  const context = useContext(MenuContext)
  if (context === undefined) {
    throw new Error("useMenuContext must be used within a MenuProvider")
  }
  return context
}
